<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex">
				<el-input v-model.trim="searchFrom.userName" class="w190" size="small" placeholder="用户名" maxlength="10" @keyup.enter.native="handleSearch"
					clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.userCode" class="w190 ml10" size="small" placeholder="账号" maxlength="16" @keyup.enter.native="handleSearch"
					clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.userPhone" class="w190 ml10" size="small" placeholder="联系电话" maxlength="11" @keyup.enter.native="handleSearch"
					clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.groupName" class="w190 ml10" size="small" placeholder="组织部门" readonly 
					@focus="showGroupTree"></el-input>
				<el-select v-model="searchFrom.userStatus" class="ml15 w190" size="small" placeholder="用户状态" clearable @change="handleSearch()">
					<el-option  label="正常" value="0"></el-option>
					<el-option  label="停用" value="1"></el-option>
				</el-select>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
			</div>
			<div v-if="isEdit">
				<img class="icon-img" src="@/assets/images/disable.png" @click="updateStatusRow(1)" title="停用" alt="">
				<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow(0)" title="启用" alt="">
				<img class="icon-img ml7" src="@/assets/images/resetPwd.png" @click="userResetRow" title="重置密码" alt="">
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
				<!-- <img class="icon-img ml7" src="@/assets/images/down.png" @click="userExport" title="导出" alt=""> -->
			</div>
		</div>
		<div class="table-container">
			<el-table v-if="tableData.length>0"
				ref="multipleTable"
				class="mgrTable"
				v-el-table-infinite-scroll="tableLoad"
				:height="height"
				:infinite-scroll-distance="50"
				:infinite-scroll-immediate="false"
				:data="tableData"
				:row-class-name="tabRowClassName" :cell-style="cellStyle" @selection-change="handleSelectionChange"
				@cell-click="handleCellClick" border style="width: 100%"
				:row-key="(row) => {return row.dataKey}"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}">
				<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
				</el-table-column>
				<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index" :prop="value.prop" sortable :column-key="value.prop"
					:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
					<template slot-scope="scope">
						{{scope.row[value.prop]}}
					</template>
				</el-table-column>
			</el-table>
			<el-empty v-else :style="{height:height+'px'}"  description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png" @click="userExport" title="导出" alt="">
			</div>
		</div>
		<userEdit ref="userEdit" @getList="handleSearch"></userEdit>
		<!--组织树 -->
		<groupTree v-if="groupTreeDialog" ref="groupTree" @groupIdListener="groupIdCallback"
			@groupNameListener="groupNameCallback">
		</groupTree>

	</div>
</template>

<script>
	import {debounce} from '@/utils/debounce'
	import userEdit from './components/user-edit.vue'
	import groupTree from '@/components/groupTree1/index.vue';
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'userManagement',
		components: {
			userEdit,
			groupTree
		},
		data() {
			return {
				height: 500,
				pageNo: 1,
				pageSize: 50,
				totalPage: 100,
				searchFrom: {
					userCode: "",
					userName: "",
					userPhone: "",
					groupName: "",
					groupIds: [],
					userStatus:"",
				},
				tableData: [],
				titles: [],
				groupTreeDialog: false,
				treeData: [],
				multipleSelection: [],
				isEdit:false,
				totalPage:"",
				totalCount:"",
				currentNo:"",
			}
		},
		created() {
			// this.height = window.innerHeight - 145;
			this.getList();
			this.getTree();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 130 - height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 新增
			handleEdit() {
				this.$refs.userEdit.init(this.treeData)
			},
			// 查看/编辑
			editRow(val) {
				this.$refs.userEdit.init(this.treeData, val)
			},
			handleCellClick(row, column, cell, event) {
				if (column.label == '用户名称') {
					this.$refs.userEdit.init(this.treeData, row);
				} else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			// 获取列表
			getList(type) {
				let that = this;
				that.$request.post(
						"userList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							userCode: that.searchFrom.userCode,
							userName: that.searchFrom.userName,
							userPhone: that.searchFrom.userPhone,
							groupIds: that.searchFrom.groupName == '' ? [] : that.searchFrom.groupIds,
							userStatus:that.searchFrom.userStatus,
						}
					)
					.then((res) => {
						if (res) {
							if (type == 'scroll') {
								that.tableData = that.tableData.concat(res.data.tableDatas);
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							} else {
								if (res.data && res) {
									that.titles = res.data.titles
									that.tableData = res.data.tableDatas
									that.totalPage = res.data.totalPage
									that.totalPage=res.data.totalPage
									that.totalCount=res.data.totalCount
									that.currentNo = res.data.pageNo
								} else {
									that.titles = []
									that.tableData = []
									that.totalPage=0
									that.totalCount=0
									that.currentNo = 0
								}
							}
						}
						that.titles  = that.titles.map((item, index) => { 
									return { 
										title: item.title, 
										prop: 'tr' + index,
										maxWidth:item.maxWidth, 
									} 
								})
						that.tableData.forEach(item => {
							for (let i = 0; i < that.titles.length; i++) {
								item['tr' + i] = item.datas[i] || ''
							}
						})

					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				if(this.pageNo >= this.totalPage) {
					return
				}
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			handleSearch() {
				if(this.tableData.length > 0){
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// 获取组织树
			getTree() {
				let that = this;
				that.$request.post(
						"tree",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.treeData = res.data
						}
					})
			},
			// groupId回调
			groupIdCallback(val) {
				this.searchFrom.groupIds = [val];
				this.handleSearch()
			},
			// groupName回调
			groupNameCallback(val) {
				this.searchFrom.groupName = val
			},
			// 组织树
			showGroupTree() {
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					this.$refs.groupTree.init(this.treeData);
				});
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let userIds = []
				that.multipleSelection.forEach(item => {
					userIds.push(item.dataKey)
				});
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"userDelete",
							false, {
								userIds: userIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 状态
			updateStatusRow(status) {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let userIds = []
				that.multipleSelection.forEach(item => {
					userIds.push(item.dataKey)
				});
				that.$request.post(
						"updateStatus",
						false, {
							userIds: userIds,
							userStatus: status
						}
					)
					.then((res) => {
						if (res) {
							// 0:正常;1:停用
							that.$message.success(status == 0 ? "已启用！" : "已停用！");
							that.handleSearch()
						}
					})

			},
			// 重置密码
			userResetRow() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let userIds = []
				that.multipleSelection.forEach(item => {
					userIds.push(item.dataKey)
				});
				that.$confirm('确认要重置选中用户的密码吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"userReset",
							false, {
								userIds: userIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("重置成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 导出
			userExport() {
				let that = this;
				that.$request.post(
						"userExport",
						false, {
							userCode: that.searchFrom.userCode,
							userName: that.searchFrom.userName,
							userPhone: that.searchFrom.userPhone,
							groupIds: that.searchFrom.groupIds,
							userStatus:that.searchFrom.userStatus,
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		padding-bottom: 0;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
		box-sizing: border-box;
	}

	.el-table__body-wrapper {
		overflow-y: scroll !important;
	}
	.w190 {
		width: 150px !important;
	}
</style>
